import { useState } from 'react';

import { fmtRangeLabel, PRESETS } from '../lib/dateRange';
import { useDateRange } from '../lib/useDateRange';
import { Input } from './Input';

const chipCls = (active: boolean) =>
  `h-8 px-3.5 rounded-chip border text-sm-label font-semibold transition-colors ${
    active
      ? 'bg-primary border-primary text-white'
      : 'bg-surface border-line text-ink-2 hover:border-primary hover:text-primary'
  }`;

/** Global report date range: preset chips + a custom-range popover. URL-backed (see useDateRange). */
export function DateRangeFilter() {
  const {
    preset,
    range,
    prev,
    setPreset,
    setCustom,
    customFromIso,
    customToIso,
  } = useDateRange();
  const [open, setOpen] = useState(false);

  return (
    <div className="bo-card p-3 mb-6 flex flex-wrap items-center gap-x-4 gap-y-2">
      <span className="text-sm-label font-bold text-ink-3 uppercase tracking-wider">
        ช่วงเวลา
      </span>
      <div className="flex flex-wrap gap-1.5">
        {PRESETS.map((p) =>
          p.key === 'custom' ? (
            <div key="custom" className="relative">
              <button
                onClick={() => setOpen((o) => !o)}
                aria-haspopup="dialog"
                aria-expanded={open}
                className={chipCls(preset === 'custom')}
              >
                {p.label}…
              </button>
              {open && (
                <>
                  <div
                    className="fixed inset-0 z-0"
                    onClick={() => setOpen(false)}
                    aria-hidden="true"
                  />
                  <div
                    role="dialog"
                    aria-label="เลือกช่วงวันที่"
                    className="absolute left-0 mt-1.5 z-10 bo-card p-3 flex flex-col gap-2.5 w-56"
                  >
                    <label className="flex flex-col gap-1 text-sm-label font-semibold text-ink-2">
                      จากวันที่
                      <Input
                        type="date"
                        defaultValue={customFromIso}
                        max={customToIso}
                        onChange={(e) =>
                          e.target.value &&
                          setCustom(e.target.value, customToIso)
                        }
                      />
                    </label>
                    <label className="flex flex-col gap-1 text-sm-label font-semibold text-ink-2">
                      ถึงวันที่
                      <Input
                        type="date"
                        defaultValue={customToIso}
                        min={customFromIso}
                        onChange={(e) =>
                          e.target.value &&
                          setCustom(customFromIso, e.target.value)
                        }
                      />
                    </label>
                  </div>
                </>
              )}
            </div>
          ) : (
            <button
              key={p.key}
              onClick={() => setPreset(p.key)}
              className={chipCls(preset === p.key)}
            >
              {p.label}
            </button>
          ),
        )}
      </div>
      <div className="ml-auto text-sm-label text-ink-3">
        แสดง <b className="text-ink font-semibold">{fmtRangeLabel(range)}</b>
        <span className="mx-1.5 text-ink-4">·</span>
        เทียบ <b className="text-ink-2 font-medium">{fmtRangeLabel(prev)}</b>
      </div>
    </div>
  );
}
